import { Injectable } from '@angular/core';
import { SubscriberMetricsService } from '../services/subscriber-metrics.service';

@Injectable()
export class SubscriberMetricsMockService extends SubscriberMetricsService {
  // override getInsertionByMedia(
  //   ...params: Parameters<SubscriberMetricsService['getInsertionByMedia']>
  // ): Observable<AdvertisingStats[]> {
  //   return ofDelay(ADS_OBSERVED_MOCK());
  // }
  // override getCampaignPerType(
  //   ...params: Parameters<SubscriberMetricsService['getCampaignPerType']>
  // ): Observable<CampaignPerTypeStats[]> {
  //   return ofDelay(ADS_CAMPAIGN_TYPE_MOCK);
  // }
  // override getAdvertisingExpenses(
  //   ...params: Parameters<SubscriberMetricsService['getAdvertisingExpenses']>
  // ): Observable<AdvertisingExpenses[]> {
  //   return ofDelay(ADS_MEDIA_EXPENSES_MOCK());
  // }
  // override getAdvertisingPerPeriod(
  //   ...params: Parameters<SubscriberMetricsService['getAdvertisingPerPeriod']>
  // ): Observable<AdvertisingPerPeriod[]> {
  //   return ofDelay(ADS_PER_PERIOD_MOCK());
  // }
  // override getAdvertisingPerTimeSlot(
  //   ...params: Parameters<SubscriberMetricsService['getAdvertisingPerTimeSlot']>
  // ): Observable<AdvertisingPerTimeSLot[]> {
  //   return ofDelay(ADS_PER_TIME_SLOT_MOCK());
  // }
}
